import { render } from "./Table.vue?vue&type=template&id=244e8ebf&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Devices/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "244e8ebf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('244e8ebf', __exports__)) {
    console.log('reload')
    api.reload('244e8ebf', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=244e8ebf&ts=true", () => {
    console.log('re-render')
    api.rerender('244e8ebf', render)
  })

}


export default __exports__